export default __webpack_public_path__ + "static/media/topimg.1ce9f812.svg";